<template>
    <!-- 主菜单 -->
    <ModuleIndex2></ModuleIndex2>
  </template>
  <script>
  export default {
    
  }
  </script>
  <style lang="less" scoped>
  </style>